import MuiButton from '@mui/material/Button'
import styled from '@mui/material/styles/styled'

export const FilterClearButton = styled(MuiButton, {
  name: 'FilterClearButton',
  slot: 'Root',
  skipSx: true,
})`
  text-transform: capitalize !important;
  white-space: nowrap;
  padding-top: 4px;
  padding-bottom: 4px;
  margin-top: -4px;
`
